import React, { useState, useCallback } from 'react';
import styles from './LeadForm.module.sass';

export function LeadForm({
  phoneLabel,
  phonePlaceholder,
  nameLabel,
  namePlaceholder,
  submitLabel,
  consentLabel,
  disclaimer,
  onSubmit,
  variant,
}) {
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [consent, setConsent] = useState(false);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      onSubmit?.(e, { phone, name, consent });
    },
    [onSubmit, phone, name, consent],
  );

  const formClass =
    variant === 'viewing'
      ? `${styles.leadForm} ${styles.leadForm_viewing}`
      : styles.leadForm;

  return (
    <>
      <form className={formClass} onSubmit={handleSubmit}>
        <div className={styles.leadForm__field}>
          <label className={styles.leadForm__label}>{phoneLabel}</label>
          <input
            type="tel"
            className={styles.leadForm__input}
            placeholder={phonePlaceholder}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <div className={styles.leadForm__field}>
          <label className={styles.leadForm__label}>{nameLabel}</label>
          <input
            type="text"
            className={styles.leadForm__input}
            placeholder={namePlaceholder}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <button type="submit" className={styles.leadForm__submit}>
          {submitLabel}
        </button>
      </form>

      <div
        className={
          variant === 'viewing'
            ? `${styles.leadForm__legal} ${styles.leadForm__legal_viewing}`
            : styles.leadForm__legal
        }
      >
        <label className={styles.leadForm__consent}>
          <span
            className={`${styles.leadForm__checkbox} ${consent ? styles['leadForm__checkbox--checked'] : ''}`}
            aria-hidden
          />
          <input
            type="checkbox"
            className={styles.leadForm__checkboxInput}
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
          />
          <span className={styles.leadForm__consentText}>{consentLabel}</span>
        </label>

        <p
          className={styles.leadForm__disclaimer}
          dangerouslySetInnerHTML={{ __html: disclaimer }}
        />
      </div>
    </>
  );
}
